import { Inventory } from "@mui/icons-material";
import { supabase } from "../supabaseClient";
import { sortBy } from "lodash";

// Define the page number and items per page
const page = 1; // The current page number
const perPage = 10; // Number of records per page
// Calculate the offset based on the page number and items per page
// const offset = (page - 1) * perPage;
function getToken(str) {
  let arrOfStr = str.split("-");
  arrOfStr.shift();
  return arrOfStr.join("-");
}

function getQueryStr(arr, field) {
  let strArr = [];
  for (const value of arr) {
    strArr.push(`${field}.eq.${value}`);
  }
  return strArr.join(",");
}

async function getPayments(
  benefitPlanId,
  planName,
  checked,
  search,
  drpDownSelectedVal,
  from,
  to,
  refundRequest,
  range = { from: 0, to: 9 }
) {
  const filters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "lastupdated",
      isAscending: true,
    },
    "Latest First": {
      key: "lastupdated",
      isAscending: false,
    },
  };
  // let query = supabase
  //   .rpc("tokentransactionsfilter")
  //   .order(filters[drpDownSelectedVal].key, {
  //     ascending: filters[drpDownSelectedVal].isAscending,
  //   })
  //   .limit(10)
  //   .range(range.from, range.to);
  let query = supabase
    .rpc("tokentransactionsfilter", {}, { count: "exact" }) // count :"exact"
    .order(filters[drpDownSelectedVal].key, {
      ascending: filters[drpDownSelectedVal].isAscending,
    })
    .limit(10)
    .range(range.from, range.to);
  let query2 = await supabase
    .from("EventTokenLeadRelations")
    .select("*", { count: "exact", head: true });
  // .offset(offset);
  // range.from += range.to;
  // range.to += range.to;

  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_TokenId = [];
  let all_InventoryTypeId = [];
  let all_PaymentStatus = [];
  let all_AllotmentStatus = [];
  let jsonParse;

  if (benefitPlanId) {
    query = query.eq("benefitPlanId", benefitPlanId).maybeSingle();
  }

  // if (planName) {
  //   query = query.ilike("planName", '%' + planName + '%');
  // }

  if (checked) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Events") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter === "Tokens") {
        all_TokenId.push(jsonParse.value);
      } else if (jsonParse.filter === "InventoryType") {
        all_InventoryTypeId.push(jsonParse.value);
      } else if (jsonParse.filter === "PaymentStatus") {
        all_PaymentStatus.push(jsonParse.value);
      } else if (jsonParse.filter === "AllotmentStatus") {
        all_AllotmentStatus.push(jsonParse.value);
      }
    });
  }

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_projectId.length !== 0) {
    query = query.in("eventid", all_projectId);
  }

  if (all_TokenId.length !== 0) {
    query = query.in("tokenid", all_TokenId);
  }

  if (all_InventoryTypeId.length !== 0) {
    query = query.in("inventorytypeid", all_InventoryTypeId);
  }

  if (all_PaymentStatus.length !== 0) {
    query = query.in("status", all_PaymentStatus);
  }
  // if (all_AllotmentStatus.length !== 0) {
  //   query = query.in("status", all_AllotmentStatus);
  // }
  if (search) {
    // search = search.replace(/\s\s+/g, ' ')

    // query = query.ilike("leadname", `%${search}%`);
    // query = query.ilike("tokennumber", `%${getToken(search)}%`);
    // tokennumber.eq.%${getToken(search)}%
    // query = query.or(`leadname.ilike.%${search}%`);
    query = query.ilike("leadname_tokennumber_search", `%${search}%`);
  }
  if (from) {
    query = query.gt("amount", from);
  }

  if (to) {
    query = query.lt("amount", to);
  }
  if (refundRequest) {
    query = query.in("status", ["active", "alloted"]);
  }
  if (
    JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs["Payments"][
      "Show Tokens Payments"
    ].show !== "All"
  ) {
    // !!sarita changes
    query = query.in("userid", JSON.parse(localStorage.getItem("teamIds")));
  }
  const { data, error, count } = await query;

  if (data) return { data, count: count };
  else throw error;
}

async function getAllotmentTransactions(
  benefitPlanId,
  planName,
  checked,
  search,
  drpDownSelectedVal,
  from,
  to,
  range = { from: 0, to: 9 },
  projectStr = {}
) {
  const { p, w, f } = projectStr;
  // function parseProjectStr(str) {
  //   let obj = {};
  //   let arr = str.split("&").map((kv) => kv.split("="));
  //   arr.forEach(([key, value]) => {
  //     obj[key] = value;
  //   });
  //   return obj;
  // }
  // let { p, w, f } = parseProjectStr(projectStr);

  const filters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "lastupdated",
      isAscending: true,
    },
    "Latest First": {
      key: "lastupdated",
      isAscending: false,
    },
  };
  let query = supabase
    .rpc("allotmentfilter", {}, { count: "exact" })
    .order(filters[drpDownSelectedVal].key, {
      ascending: filters[drpDownSelectedVal].isAscending,
    })
    .limit(10)
    .range(range.from, range.to);
  let query2 = await supabase
    .from("AllotmentPayment")
    .select("*", { count: "exact", head: true });
  let all_cpId = [];
  let all_projectId = [];
  let all_salesRepresentativeId = [];
  let all_TokenId = [];
  let all_InventoryTypeId = [];
  let all_AllotmentStatus = [];
  let jsonParse;
  if (benefitPlanId) {
    query = query.eq("benefitPlanId", benefitPlanId).maybeSingle();
  }

  if (planName) {
    query = query.ilike("planName", "%" + planName + "%");
  }
  if (checked) {
    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Events") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter === "Tokens") {
        all_TokenId.push(jsonParse.value);
      } else if (jsonParse.filter === "InventoryType") {
        all_InventoryTypeId.push(jsonParse.value);
      } else if (jsonParse.filter === "AllotmentStatus") {
        all_AllotmentStatus.push(jsonParse.value);
      }
    });
  }

  if (all_cpId.length !== 0) {
    query = query.in("cpid", all_cpId);
  }

  if (all_salesRepresentativeId.length !== 0) {
    query = query.in("userid", all_salesRepresentativeId);
  }

  if (all_projectId.length !== 0) {
    query = query.in("eventid", all_projectId);
  }
  if (all_TokenId.length !== 0) {
    query = query.in("tokenid", all_TokenId);
  }
  if (all_AllotmentStatus.length !== 0) {
    query = query.in("status", all_AllotmentStatus);
  }
  if (p?.length) {
    query = query.in("projectid", p);

    // query = query.or(getQueryStr(p, "projectid"));
    // query = query.or(`projectid.eq.${p[0]}`);
  }
  if (w?.length) {
    query = query.in("wingid", w);
    // query = query.or(getQueryStr(w, "wingid"));
  }
  if (f?.length) {
    query = query.in("floorno", f);
    // query = query.or(getQueryStr(f, "floorno"));
  }
  // if (p?.length || w?.length || f?.length) {
  //   query = query.or(
  //     `projectid.in.${p || []},wingid.ilike.${w || []},floorno.ilike.${f || []}`
  //   );
  // }
  // if (all_InventoryTypeId.length !== 0) {
  //   query = query.in('inventorytype', all_InventoryTypeId);
  // }
  if (search) {
    // search = search.replace(/\s\s+/g, ' ')
    // query = query.ilike("unitno", `%${search}%`);
    query = query.ilike("leadname_unitno_search", `%${search}%`);
  }
  if (from) {
    query = query.gt("amount", from);
  }

  if (to) {
    query = query.lt("amount", to);
  }
  if (
    JSON.parse(localStorage.getItem("user")).roleId.accessibleTabs["Payments"][
      "Show Allotments Payments"
    ].show !== "All"
  ) {
    // !!sarita changes
    query = query.in("userid", JSON.parse(localStorage.getItem("teamIds")));
  }
  const { data, error, count } = await query;

  // if (data) return { data };
  if (data) return { data, count: count };
  else throw error;
}

// async function getTokenTransactions(paymentId) {
//   const { data, error } = await supabase
//     .from("TokenTransactions")
//     .select("*")
//     .eq("paymentId", paymentId)
//     // .order("last_updated_at", { ascending: false });
//     .order("created_at", { ascending: false });

//   if (data) return data;
//   else throw error;
// }
async function getTokenTransactions(paymentId) {
  const { data, error } = await supabase
    .from("TokenTransactions")
    .select("*")
    .eq("paymentId", paymentId)
    // .order("last_updated_at", { ascending: false });
    .order("created_at", { ascending: false });

  if (error) {
    throw error;
  }

  if (data && data.length > 0) {
    const payIds = data.map(item => item.payId);
    const { data: transactionData, error: transactionError } = await supabase
      .from("Transactions")
      .select("id,payId,refundPayload")
      .in("payId", payIds);

    if (transactionError) {
      throw transactionError;
    }

    const enrichedTokenTransactions = data.map(tokenTransaction => {
      const matchingTransaction = transactionData.find(
        transaction => transaction.payId === tokenTransaction.payId
      );
      return {
        ...tokenTransaction,
        transactionDetails: matchingTransaction || null,
      };
    });
    return enrichedTokenTransactions;
  } else {
    return [];
  }
}

// async function getAllotmentTransactionsTimeline(allotmentPaymentId) {
//   const { data, error } = await supabase
//     .from("AllotmentTransactions")
//     .select("*")
//     .eq("allotmentPaymentId", allotmentPaymentId)
//     .order("last_updated_at", { ascending: false });

//   if (data) return data;
//   else throw error;
// }
async function getAllotmentTransactionsTimeline(allotmentPaymentId) {
  // First query: Fetch data from AllotmentTransactions table
  const { data, error } = await supabase
    .from("AllotmentTransactions")
    .select("*")
    .eq("allotmentPaymentId", allotmentPaymentId)
    .order("last_updated_at", { ascending: false });

  if (error) {
    throw error;
  }

  if (data && data.length > 0) {
    const payIds = data.map(item => item.payId).filter(Boolean);

    let transactionData = [];
    if (payIds.length > 0) {
      const { data: txData, error: transactionError } = await supabase
        .from("Transactions")
        .select("id,payId,refundPayload")
        .in("payId", payIds);

      if (transactionError) throw transactionError;
      transactionData = txData || [];
    }

    const enrichedAllotmentTransactions = data.map(allotmentTransaction => {
      const matchingTransaction = transactionData.find(
        transaction => transaction.payId === allotmentTransaction.payId
      );
      return {
        ...allotmentTransaction,
        transactionDetails: matchingTransaction || null,
      };
    });
    return enrichedAllotmentTransactions;
  } else {
    return [];
  }
}


async function getAllotmentCancelledTransection(allotmentPaymentId) {
  const { data, error } = await supabase
    .from("CancelUnitRequests")
    .select("*")
    .eq("allotmentPaymentId", allotmentPaymentId)
    .order("created_at", { ascending: false });

  if (data) return data;
  else throw error;
}

async function getEventList() {
  let projects = await supabase
    .from("Projects")
    .select("projectId,projectName, Wings(wingId,wingName,displayName)")
    .eq("isVJ", true);
  // let floor = await supabase.rpc("getuniquefloors", {
  //   projectid: "1f08bdb3-390a-4c8e-91cd-f742559d4491",
  //   wingid: "36abd048-8cbe-4538-8bee-662c16236197",
  // });
  // console.log({ _floor: floor });
  // let projects = await supabase
  //   .from("Projects")
  //   .select(
  //     "projectId,projectName, Wings(wingId,wingName,Inventory(unitId,unitNo,floorNo ))"
  //   );
  let data = projects.data;
  // unitId,unitNo,floorNo
  // wokin
  // data = data.map((project) => {
  //   return {
  //     id: `p=${project.projectId}`,
  //     label: project.projectName,
  //     children: project.Wings.map(async (wing) => {
  //       const floor = await supabase.rpc("getuniquefloors", {
  //         projectid: project.projectId,
  //         wingid: wing.wingId,
  //       });
  //       let data = floor.data;
  //       return {
  //         id: `p=${project.projectId}&w=${wing.wingId}`,
  //         label: wing.wingName,
  //         children: data.map((inventory) => {
  //           return {
  //             id: `p=${project.projectId}&w=${wing.wingId}&f=${inventory.floorno}`,
  //             label: inventory.floorno,
  //           };
  //         }),
  //       };
  //     }),
  //   };
  // });
  // wkin

  function customSort(a, b) {
    // Check if either value is a number
    const aIsNumber = !isNaN(a.floorno);
    const bIsNumber = !isNaN(b.floorno);

    if (aIsNumber && bIsNumber) {
      // Both values are numbers, compare numerically
      return Number(a.floorno) - Number(b.floorno);
    } else if (aIsNumber) {
      // Only `a` is a number, `a` should come first
      return -1;
    } else if (bIsNumber) {
      // Only `b` is a number, `b` should come first
      return 1;
    } else {
      // Neither value is a number, compare alphabetically
      return a.floorno.localeCompare(b.floorno);
    }
  }

  // const sortedData = data.sort(customSort);
  data = await Promise.all(
    data.map(async (project) => {
      return {
        id: `p=${project.projectId}`,
        label: project.projectName,
        children: await Promise.all(
          project.Wings.map(async (wing) => {
            const floor = await supabase.rpc("getuniquefloors", {
              projectid: project.projectId,
              wingid: wing.wingId,
            });
            // .order("floorno", { ascending: true });
            let data = floor.data;

            if (data.length) {
              sortBy(data, (fl) => {
                return isNaN(parseInt(fl.floorno.split(" ")[1]))
                  ? 0
                  : parseInt(fl.floorno.split(" ")[1]);
              });
            }
            // console.log({
            //   floor9: data.sort((a, b) => {
            //     if (Number(a.floorno)) {
            //       return Number(a.floorno) - Number(b.floorno);
            //     } else {
            //       const floorA = parseInt(a.floorno.split(" ")[1]);
            //       const floorB = parseInt(b.floorno.split(" ")[1]);
            //       return floorA - floorB;
            //     }
            //   }),
            // });
            data = data.sort((a, b) => {
              if (Number(a.floorno)) {
                return Number(a.floorno) - Number(b.floorno);
              } else {
                const floorA = parseInt(a.floorno.split(" ")[1]);
                const floorB = parseInt(b.floorno.split(" ")[1]);
                return floorA - floorB;
              }
            });
            return {
              id: `p=${project.projectId}&w=${wing.wingId}`,
              label: wing.displayName ? wing.displayName : wing.wingName,
              children: data.map((inventory) => {
                return {
                  id: `p=${project.projectId}&w=${wing.wingId}&f=${inventory.floorno}`,
                  label: `${inventory.floorno}`,
                };
              }),
            };
          })
        ),
      };
    })
  );

  // console.log(data);

  // console.log({ _projects: data });
  return data;
}

async function getWingList(id) {
  let projects = await supabase
    .from("Projects")
    .select("projectId,projectName, Wings(wingId,wingName,displayName)")
    .eq("isVJ", true);

  const selectedProject = projects.data.filter(
    (val) => val.projectId === id.substring(2)
  );

  let data = selectedProject;
  data = await Promise.all(
    data.map(async (project) => {
      return {
        id: `p=${project.projectId}`,
        label: project.projectName,
        children: await Promise.all(
          project.Wings.map(async (wing) => {
            const floor = await supabase.rpc("getuniquefloors", {
              projectid: project.projectId,
              wingid: wing.wingId,
            });
            // .order("floorno", { ascending: true });
            let data = floor.data;

            if (data.length) {
              sortBy(data, (fl) => {
                return isNaN(parseInt(fl.floorno.split(" ")[1]))
                  ? 0
                  : parseInt(fl.floorno.split(" ")[1]);
              });
            }
            // console.log({
            //   floor9: data.sort((a, b) => {
            //     if (Number(a.floorno)) {
            //       return Number(a.floorno) - Number(b.floorno);
            //     } else {
            //       const floorA = parseInt(a.floorno.split(" ")[1]);
            //       const floorB = parseInt(b.floorno.split(" ")[1]);
            //       return floorA - floorB;
            //     }
            //   }),
            // });
            data = data.sort((a, b) => {
              if (Number(a.floorno)) {
                return Number(a.floorno) - Number(b.floorno);
              } else {
                const floorA = parseInt(a.floorno.split(" ")[1]);
                const floorB = parseInt(b.floorno.split(" ")[1]);
                return floorA - floorB;
              }
            });
            return {
              id: `p=${project.projectId}&w=${wing.wingId}`,
              label: wing.displayName ? wing.displayName : wing.wingName,
              parent: `p=${project.projectId}`,
              children: data.map((inventory) => {
                return {
                  parent: `p=${project.projectId}&w=${wing.wingId}`,
                  id: `p=${project.projectId}&w=${wing.wingId}&f=${inventory.floorno}`,
                  label: `${inventory.floorno}`,
                };
              }),
            };
          })
        ),
      };
    })
  );

  return data;
}

async function getProjectList(selectedIds=[]) {
  let query = supabase
    .from("Projects")
    .select("projectId,projectName ,bannerImages, Wings(wingId,wingName,displayName)")
    .eq("isVJ", true)

  if(selectedIds?.length > 0){
    query = query.in("projectId",selectedIds)
  }
  let projects = await query;
  let data = projects.data;

  data = await Promise.all(
    data.map(async (project) => {
      return {
        id: `p=${project.projectId}`,
        label: project.projectName,
        children: [""],
      };
    })
  );

  // console.log(data);

  // console.log({ _projects: data });
  return data;
}

export {
  getPayments,
  getAllotmentTransactions,
  getAllotmentTransactionsTimeline,
  getAllotmentCancelledTransection,
  getTokenTransactions,
  getEventList,
  getProjectList,
  getWingList,
};
